import React from "react"
import { Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import moment from 'moment';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      display: false
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false
      },
      ticks: {
        stepSize: 1
      }
    }
  }
}

const labels: string[] = ['Lun', 'Mar', 'Mer', "Jeu", 'Ven', 'Sam', 'Dim']

const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [10, 14, 20, 8, 14, 18, 5],
      borderColor: 'rgb(15, 10, 222)',
      backgroundColor: 'rgb(15, 10, 222, 0.5)',
    },
    {
      label: 'Dataset 2',
      data: [10, 14, 20, 8, 14, 18, 5],
      borderColor: 'rgb(207, 0, 15)',
      backgroundColor: 'rgb(207, 0, 15, 0.5)',
    },
  ],
};

const formatPerf = (perf, date) => {
  const today = new Date(date)
  const start = moment(new Date(today.setDate(today.getDate() - today.getDay() + 0))).startOf("day");
  const end = moment(new Date(today.setDate(today.getDate() - today.getDay() + 7))).startOf("day");

  let result: string[] = []

  while (start.add(1, 'days').diff(end) <= 0) {
    result.push(start.clone().format("YYYY-MM-DD"));
  }

  let obj: { resolved: number[], unresolved: number[] } = {
    resolved: [],
    unresolved: []
  }

  result.forEach((elem) => {
    const foundResolved = perf?.find((i: any) => i._id.date === elem && i._id.resolved === true)
    const foundUnresolved = perf?.find((i: any) => i._id.date === elem && i._id?.resolved === false)
    if (foundResolved)
      obj.resolved.push(foundResolved.count)
    else
      obj.resolved.push(0)
    if (foundUnresolved)
      obj.unresolved.push(foundUnresolved.count)
    else
      obj.unresolved.push(0)
  })

  return {
    labels,
    datasets: [
      {
        label: 'Resolu',
        data: obj.resolved,
        borderColor: 'rgb(15, 10, 222)',
        backgroundColor: 'rgb(15, 10, 222, 0.5)',
      },
      {
        label: 'Erreur',
        data: obj.unresolved,
        borderColor: 'rgba(248, 113, 113, 1)',
        backgroundColor: 'rgba(248, 113, 113, 1)',
      },
    ],
  };
}

const PerformanceChart = (props: { performance: any, date: moment.Moment }) => {
  const { performance, date } = props

  return (
    <Bar
      options={options}
      data={performance ? formatPerf(performance, date) : data}
    />
  )
}

export default PerformanceChart